import React, { useEffect, useRef, useState } from 'react';
import metaDataServices from '../MetaDataServices';
import { RegionTerritories } from 'components/Common/regionTerritories';
import Drawer from 'react-modern-drawer';
import { CommonUtilities } from 'commonUtils';
import songServices from '../Song/songServices';
import { ContactFormSearch } from 'components/Contacts/contactFormSearch';
import { SearchContract } from 'components/Contracts/SearchContract';
import { SongSplitsCollector } from './songSplitsCollector';
import Pagination from 'components/Common/newPagination';

export function PublishingSongSplits(songSplitsDetail: any) {

    console.log(songSplitsDetail)
    let [activeTab, setactiveTab] = useState(0);
    let [composerOpen, setcomposerOpen] = useState(false);
    let [PublisherOpen, setPublisherOpen] = useState(false);
    let [songReference, setSongReference] = useState<any>([]);
    let [editDataParam, setEditDataParam] = useState<any>([]);
    let [songSplitsTotalRow, setSongSplitsTotalRow] = useState(0);
    let [PublishingTypes, setPublishingTypes] = useState<any>([]);
    let [selectedSongSlit, setSelectedSongSlit] = useState<any>([]);
    let [openSearchContract, setopenSearchContract] = useState(false);
    let [songSplitsListing, setSongSplitsListing] = useState<any>([]);
    let [openRegionTerritories, setopenRegionTerritories] = useState(false);
    let [openSongSplitsCollector, setopenSongSplitsCollector] = useState(false);

    var songSplitPayload = {
        songID: songSplitsDetail?.song?.songID,
        songName: songSplitsDetail?.song?.songName,
        songMainPublisher: songSplitsDetail?.song?.songMainPublisher,
        songMainComposer: songSplitsDetail?.song?.songMainComposer,
        publishingLevel: 0,
        PageNumber: 1,
        PageSize: 10,
    }

    const closePublishingSongSplits = () => { songSplitsDetail.closePublishingSongSplits(); }

    const closeRegionTerritories = () => { setopenRegionTerritories(false) }

    let [totalSplitCss, settotalSplitCss] = useState(0);
    const searchSongSplit = () => {
        totalSplitCss = 0
        settotalSplitCss(totalSplitCss)

        metaDataServices.songSplitsListing(songSplitPayload).then((values: any) => {
            setSongSplitsListing(values)
            setSongSplitsTotalRow(values && values[0] && values[0].totalRows ? values[0].totalRows : 0)
            for (var i = 0; values[i]; i++) {
                totalSplitCss = totalSplitCss + values[i]?.mechSplit
                settotalSplitCss(totalSplitCss)
            }
        });
    };

    useEffect(() => {
        console.log(songSplitsDetail)

        if (songSplitsDetail.openPublishingSongSplits) {
            searchSongSplit();
            songServices.songReference().then((respond: any) => {
                songReference = respond
                setSongReference(songReference)
            })

            metaDataServices.getPublishingTypes().then((values: any) => {
                setPublishingTypes(values)
            })

        }

        if (songSplitsDetail?.data) {
            editDataParam = songSplitsDetail?.data;
            setEditDataParam(editDataParam)
        }
    }, []);

    const selectRegion = (e: any) => {
        console.log(e)

        if (e?.region.length > 0) {
            editDataParam.regionList = e?.region?.join()
        }

        if (e?.territory.length > 0) {

            var array_territory: any = []

            for (var i = 0; i < e?.territory.length; i++) {
                array_territory.push(e?.territory.territoryCode)
            }
            editDataParam.territoryList = array_territory;
        }

        setEditDataParam(editDataParam)
        closeRegionTerritories()
    };

    const splitCollSave_YN = function (selectedSongSplit: any) {
        var sameCollector = {
            songPubTID: selectedSongSplit.songPubTID
            , collectorCode: selectedSongSplit.publishers
            , collectorType: selectedSongSplit.pubType
            , mechCollSplit: selectedSongSplit.mechSplit
            , perfCollSplit: selectedSongSplit.perfSplit
            , synchCollSplit: selectedSongSplit.synchSplit
            , printCollSplit: selectedSongSplit.printSplit
            , otherCollSplit: selectedSongSplit.otherSplit
            , merchCollSplit: selectedSongSplit.merchSplit
            , contractRefNum: selectedSongSplit.writersContract
            , controlledYN: selectedSongSplit.controlledYN

        };

        songServices.songSplitsCollSave(sameCollector).then(function (data) {
            searchSongSplit();
        });

    };

    const OwnershipSplit = () => {
        editDataParam.mechSplit = editDataParam.publishingSplit;
        editDataParam.perfSplit = editDataParam.publishingSplit / 2;
        editDataParam.synchSplit = editDataParam.publishingSplit;
        editDataParam.printSplit = editDataParam.publishingSplit;
        editDataParam.otherSplit = editDataParam.publishingSplit;
        editDataParam.merchSplit = editDataParam.publishingSplit;

        setEditDataParam({ ...editDataParam })
    };

    const songSplitsSave = () => {
        console.log(editDataParam);
        console.log(songSplitsDetail);

        if (songSplitsDetail?.data?.length > 0) {
            editDataParam = { ...editDataParam, ...songSplitsDetail?.data }
        }
        setEditDataParam(editDataParam)

        metaDataServices.songSplitsSave(editDataParam).then((repond: any) => {
            CommonUtilities.showToastDawer('Song Split Successfull', 'Success')
            searchSongSplit();
        })
    };

    const songSplitsClear = () => {
        console.log(editDataParam)
        editDataParam = {};
        setEditDataParam({ ...editDataParam })

        if (songSplitsDetail?.data) {
            editDataParam = songSplitsDetail?.data;
            setEditDataParam({ ...editDataParam });
        }

        console.log(editDataParam)
    };

    const onChangeComposer = (e: any) => {
        console.log(e)

        editDataParam.writerCodeDisplay = e.kontactCode;
        editDataParam.writerCodeDisplay = e.kontactName;
        setEditDataParam({ ...editDataParam });

        composerOpen = false
        setcomposerOpen(composerOpen)
    };

    const onChangePublisher = (e: any) => {
        console.log(e)
        if (e) {
            editDataParam.publishers = e?.kontactCode
            editDataParam.publishersDisplay = e?.kontactName
            setEditDataParam({ ...editDataParam })
        }

        PublisherOpen = false
        setPublisherOpen(PublisherOpen)

    };

    const closeSearchContract = (e: any) => {
        console.log(e)
        openSearchContract = false
        setopenSearchContract(openSearchContract)

        if (e?.contractSelected) {
            editDataParam.contractTitle = e?.contractSelected?.contractTitle
            editDataParam.writerCode = e?.contractSelected?.kontactCode
            editDataParam.writerCodeDisplay = e?.contractSelected?.kontactName
            setEditDataParam({ ...editDataParam })
        }
    };

    const editSongsSplit = (splitSelected: any) => {
        editDataParam = [];
        editDataParam = splitSelected
        setEditDataParam(editDataParam)
    };

    const closeSongSplitsCollectors = (e: any) => {
        openSongSplitsCollector = false;
        setopenSongSplitsCollector(openSongSplitsCollector)
    };

    const paginationSongSplits = (e: any) => {
        songSplitPayload.PageNumber = e.PageNumber
        songSplitPayload.PageSize = e.PageSize
        searchSongSplit();
    };

    return (<>

        <Drawer open={songSplitsDetail.openPublishingSongSplits} onClose={closePublishingSongSplits} direction='right' className='react-drawer allowHscroll allowVscroll' >

            <div className="ws-8 box landing full-height-vh" style={{ zIndex: 1100 }}>
                <div className="box-header-main">  <h2> Song Splits</h2>  </div>

                <div className="row-fluid">
                    <ul className="nav nav-tabs ws-12">
                        <li className={activeTab == 0 ? "mb active" : "mb"} style={{ padding: "10px" }} onClick={() => setactiveTab(0)}> Split Details </li>
                        <li className={activeTab == 1 ? "mb active" : "mb"} style={{ padding: "10px" }} onClick={() => setactiveTab(1)}> Region and Types </li>
                    </ul>

                    <div className="box-content ws-12">

                        {(activeTab === 0) && <div className='ws-12'>

                            <div className='ws-12'>

                                <fieldset className="scheduler-border p0 m0">
                                    <legend className="scheduler-border">
                                        <h2 style={{ color: "#47529d" }} >  Song Info </h2>
                                    </legend>

                                    <div className="ws-12">

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-5 text-right pr">Song Ref : </label>
                                                <div className="label-entries ws-7">  {songSplitsDetail?.song?.songRef}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-5 text-right pr">Song Title : </label>
                                                <div className="label-entries ws-7">  {songSplitsDetail?.song?.songName}  </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-5 text-right pr">ISWC :  </label>
                                                <div className="label-entries ws-7"> {songSplitsDetail?.song?.intStdWorkCode} </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-5 text-right pr">Main Composers :  </label>
                                                <div className="label-entries ws-7"> {songSplitsDetail?.song?.songMainComposer} </div>
                                            </div>
                                        </div>

                                        <div className="ws-4">
                                            <div className="form-format">
                                                <label className="control-label ws-5 text-right pr">Main Publishers : </label>
                                                <div className="label-entries ws-7">  {songSplitsDetail?.song?.songMainPublisher}  </div>
                                            </div>
                                        </div>
                                    </div>

                                </fieldset>

                            </div>

                            <div className="form-format ws-6 hide">
                                <label className="control-label" > Song Main Lyricist</label>
                                <input type="text" placeholder="Enter Song Main Lyricist" id="Text3" name="trackName" className="text-uppercase" onChange={(e: any) => setEditDataParam({ ...editDataParam, songMainLyricistDisplay: e.target.value })} value={editDataParam?.songMainLyricistDisplay ?? ""} readOnly />
                            </div>

                            <div className="form-format ws-11 hide">
                                <label className="control-label" > Sub Publisher To</label>
                                <input type="text" className="text-uppercase" placeholder="Enter Sub Publisher To" id="Text4" name="trackName" onChange={(e: any) => setEditDataParam({ ...editDataParam, parentPublishers: e.target.value })} value={editDataParam?.parentPublishers ?? ""} readOnly />
                            </div>

                            <div className="ws-12 mtl pm box">
                                <div className="ws-6">

                                    <div className="form-format">
                                        <label className="control-label" >Select Contract*</label>

                                        <div className="ws-12">
                                            <input className="ws-10" type="text" value={editDataParam?.contractTitle ?? ""} placeholder="Select Contract" id="Collected" required name="Collected" readOnly />
                                            <button type="button" className="icon-btn info width70 height35" onClick={() => setopenSearchContract(true)}><i className="icon-user-add"></i></button>

                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label" >Writer/Composer*</label>

                                        <div className="ws-12">
                                            <input className="ws-10" type="text" value={editDataParam?.writerCodeDisplay ?? ""} placeholder="Enter Composer/Writer" id="ComposerWriter" required name="ComposerWriter" readOnly />
                                            <ContactFormSearch onChange={onChangeComposer} data={""} open={composerOpen} />
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Publisher*</label>

                                        <div className="ws-12">
                                            <input className="ws-10" type="text" placeholder="Enter Publisher" value={editDataParam?.publishersDisplay ?? ""} id="Publisher" required name="Publisher" readOnly />
                                            <ContactFormSearch onChange={onChangePublisher} data={""} open={PublisherOpen} />
                                        </div>
                                    </div>

                                </div>

                                <div className="ws-6">

                                    <div className="form-format">
                                        <label className="control-label">Contribution Type</label>
                                        <div className="label-entries ws-8">
                                            <select value={editDataParam?.contributionType ?? ""} name="contributionType" onChange={(e: any) => setEditDataParam({ ...editDataParam, contributionType: e.target.value })}>
                                                <option > Choose Contribution Type</option>

                                                {
                                                    songReference?.map((values: any) => {
                                                        if (values?.referenceType == "ContributionType") {
                                                            return <option value={values?.code} label={values?.code + " (" + (values?.description) + ")"} >{values?.referenceType} ({values?.description})</option>
                                                        }
                                                    })
                                                }

                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label" >Publisher Type</label>
                                        <div className="label-entries ws-8">
                                            <select value={editDataParam?.pubType ?? ""} name="publisherTypeList" onChange={(e: any) => setEditDataParam({ ...editDataParam, pubType: e.target.value })}>
                                                <option > Choose Publisher Type</option>

                                                {
                                                    songReference?.map((values: any) => {
                                                        if (values?.referenceType == "PublisherType") {
                                                            return <option value={values?.code} label={values?.code + " (" + (values?.description) + ")"}>{values?.referenceType} ({values?.description} )</option>
                                                        }
                                                    })
                                                }

                                            </select>
                                        </div>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label mt">Controlled
                                            Y/N</label>
                                        <div className="label-entries ws-6 mm">
                                            <input type="checkbox" className="checkbox-inline mm" value={editDataParam?.controlledYN ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, controlledYN: e.target.value })} />
                                        </div>
                                    </div>

                                    <div className="form-format ws-6 hide">
                                        <label className="control-label">Language</label>
                                        <div className="ws-12">
                                            <select value={editDataParam?.languageCode ?? ""} name="LanguageCode" onChange={(e: any) => setEditDataParam({ ...editDataParam, languageCode: e.target.value })}>
                                                <option value="?" label=""></option>
                                                <option value="0" label="(Afan) Oromo">(Afan) Oromo</option>
                                                <option value="1" label="Abkhazian">Abkhazian</option>
                                                <option value="2" label="Afar">Afar</option>
                                                <option value="3" label="Afrikaans">Afrikaans</option>
                                                <option value="4" label="Albanian">Albanian</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <hr className="ws-12" style={{ border: "solid #b5c1c7 1px" }} />

                                <div className="form-format ws-12">
                                    <label className="control-label mt"> Ownership Split*</label>

                                    <div className="label-entries mt">
                                        <div className="ws-4">
                                            <input type="number" min="0" id="Number1" name="Split" value={editDataParam?.publishingSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, publishingSplit: e.target.value })} placeholder="Enter % split" required />
                                        </div>

                                        <div className="ws-4">
                                            <button type="button" className="btn-sm icon-btn info" onClick={OwnershipSplit}>
                                                <i className="icon-arrow-right m0 p0"></i>
                                            </button>
                                        </div>

                                        <div className="help-block alert alert-danger hide"> %Split must be numeric </div>
                                    </div>
                                </div>

                                <div className="ws-12">

                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Mech</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.mechSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, mechSplit: e.target.value })} />
                                    </div>

                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Perf</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.perfSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, perfSplit: e.target.value })} />
                                    </div>

                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Sync</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.synchSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, synchSplit: e.target.value })} />
                                    </div>


                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Print</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.printSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, printSplit: e.target.value })} />
                                    </div>

                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Other</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.otherSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, otherSplit: e.target.value })} />
                                    </div>

                                    <div className='ws-4 pm'>
                                        <label className='ws-12 text-bold'>Merch</label>
                                        <input className="text-right ws-10" type="text" value={editDataParam?.merchSplit ?? ""} onChange={(e: any) => setEditDataParam({ ...editDataParam, merchSplit: e.target.value })} />
                                    </div>

                                </div>

                                <div className="box-footer">
                                    <button className="icon-btn delete btn-sm" onClick={songSplitsClear}><i className="icon-reload"></i> Clear</button>
                                    <button className="icon-btn edit pull-right" onClick={songSplitsSave}><i className="icon-save"></i> Save</button>
                                </div>
                            </div>

                        </div>}

                        {(activeTab === 1) && <div className='ws-12 box pm'>

                            <div className="ws-4" >
                                <label  >Publishing Type(s):</label>
                                <div >
                                    <select className="boxheight" value={songSplitsDetail?.song?.publisherTypeList} name="publisherTypeList">
                                        {
                                            PublishingTypes.map((value: any) => {
                                                return (
                                                    <option value="0" label={value.royaltyFormat}>SYNCHRONIZATION</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <div className="ws-6">

                                <div className="ws-4">
                                    <button className="icon-btn edit pull-left mtxl" onClick={() => setopenRegionTerritories(true)}><i className="icon-plus1"></i> Add Region </button>
                                </div>

                                <div className="ws-8 mt">
                                    <div className="ws-6">
                                        <label className="mr"> Region(s): </label>
                                        <textarea value={editDataParam?.regionList ?? ""} readOnly className="ws-11" name="regions"></textarea>
                                    </div>

                                    <div className="ws-6">
                                        <label className="mr"> Territory(s): </label>
                                        <textarea value={editDataParam?.territoryList ?? ""} readOnly className="ws-11" name="territories"></textarea>
                                    </div>
                                </div>

                            </div>
                        </div>}
                    </div>

                </div>

                {(activeTab === 0) && <div className="pm ">

                    <div className="ws-12 box">
                        <div className="box-header well"> <h2>{songSplitsTotalRow} record(s) found</h2>  </div>

                        <div className="box-content">
                            {songSplitsTotalRow == 0 && <div className="alert alert-info">No splits to display for this track</div>}

                            {songSplitsTotalRow > 0 && <div className="table-responsive allowHscroll allowVscroll">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th className="forceSingleLine">Composer/Writer</th>
                                            <th className="forceSingleLine">Type</th>
                                            <th className="forceSingleLine">Publisher</th>
                                            <th className="forceSingleLine">Type</th>
                                            <th className='hide'>Contract</th>
                                            <th className="forceSingleLine">Controlled</th>
                                            <th className="forceSingleLine">% Split </th>
                                            <th className="forceSingleLine">Mech</th>
                                            <th className="forceSingleLine">Perf</th>
                                            <th className="forceSingleLine">Sync</th>
                                            <th className="forceSingleLine">Print</th>
                                            <th className="forceSingleLine">Other</th>
                                            <th className="forceSingleLine">Merch</th>
                                            <th className="forceSingleLine">Operations</th>
                                            <th className="forceSingleLine">Same Collector</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {songSplitsListing.map((value: any) => {
                                            return (
                                                <tr>
                                                    <td className="forceSingleLine text-uppercase"> {value.writerCodeDisplay} </td>
                                                    <td className="forceSingleLine">{value.contributionType} </td>
                                                    <td className="forceSingleLine text-uppercase"> {value.publishersDisplay}</td>
                                                    <td className="forceSingleLine">{value.pubType}</td>
                                                    <td className='hide'>{value.contractTitle}</td>
                                                    <td className="forceSingleLine">{value.controlledYN}</td>
                                                    <td className="text-right bg-white">{value.publishingSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.mechSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.perfSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.synchSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.printSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.otherSplit}</td>
                                                    <td className="forceSingleLine text-right">{value.merchSplit}</td>
                                                    <td className="forceSingleLine">

                                                        <div className='width100'>
                                                            {(!value.subPublisersCount && false) && <button className="icon-btn edit btn-sm pull-left" ng-show="split.subPublisersCount" data-ng-click="loadSubPublisherListing(split, splitIndex)">
                                                                <i className="icon-eye"></i> View (0)
                                                            </button>}

                                                            {(!value.subPublisersCount && false) && <button className="icon-btn warning btn-sm pull-left" ng-show="!split.subPublisersCount ; false">
                                                                <i className="icon-eye"></i> View (0)
                                                            </button>}

                                                            <button className="icon-btn edit btn-sm pull-left hide" data-ng-click="subPublisherSplit(split)">
                                                                <i className="icon-plus"></i> Sub Publishers
                                                            </button>

                                                            {false && <a ng-click="deleteSplit(split, frmmechSplits)" className="btn-sm icon-btn delete">
                                                                <i className="icon-trashcan"></i>
                                                            </a>}

                                                            <a className="btn-sm icon-btn edit" onClick={() => editSongsSplit(value)}><i className="icon-edit"></i></a>

                                                            <a onClick={() => { setopenSongSplitsCollector(true); setSelectedSongSlit(value) }} className="btn-sm icon-btn edit"><i className="icon-eye"></i> </a>
                                                        </div>

                                                    </td>
                                                    <td className="forceSingleLine text-right">
                                                        {value.collectedFlag === 0 && <button className="icon-btn warning pull-right ml" onClick={() => splitCollSave_YN(value)}>  + / -   </button>}

                                                    </td>
                                                </tr>
                                            )
                                        })}

                                        <tr className="text-right text-bold text-xxl text-uppercase">
                                            <td className="text-right " colSpan={5}>Total</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('publishingSplit', 'split'));">100</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('mechSplit', 'split'));">100</td>
                                            <td className="text-right bg-primary "  >{totalSplitCss}</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('printSplit', 'split'));">100</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('otherSplit', 'split'));">100</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('synchSplit', 'split'));">100</td>
                                            <td className="text-right bg-green hide" ng-className="totalSplitCss(totalSplit('merchSplit', 'split'));">100</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>}

                            <div className="clearfix">
                                {
                                    (() => {
                                        if (songSplitsTotalRow > 10) {
                                            return <Pagination onPageChange={paginationSongSplits} totalRow={songSplitsTotalRow} />
                                        }
                                    })()
                                }
                            </div>

                        </div>
                    </div>

                </div>}

                {
                    (() => {

                        if (openRegionTerritories) {
                            return <RegionTerritories openRegionTerritories={true} data={editDataParam} closeRegionTerritories={closeRegionTerritories} selectRegion={selectRegion} />
                        }

                        if (openSearchContract) {
                            return <SearchContract openSearchContract={openSearchContract} data={editDataParam} closeSearchContract={closeSearchContract} />
                        }

                        if (openSongSplitsCollector) {
                            return <SongSplitsCollector data={selectedSongSlit} song={songSplitsDetail?.song} openSongSplitsCollector={openSongSplitsCollector} closeSongSplitsCollectors={closeSongSplitsCollectors} />
                        }

                    })()
                }

                <div className="box-footer pull-right">
                    <button className="icon-btn delete" onClick={closePublishingSongSplits}><i className="icon-close"></i> Close</button>
                </div>

            </div>

        </Drawer>

    </>)
}